// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css'; // Ensure you have the correct CSS file

// Import Font Awesome icons (you can install it if you don't have it already)
import { FaTwitter, FaLinkedin } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p>Security in Software, Hardware and Cryptography (SeCLab)</p>
        </div>
        <div className="footer-right">
          <ul className="footer-icons">
            <li><a href="https://x.com/i/flow/login?redirect_after_login=%2Fcatedraciber" target="_blank" rel="noopener noreferrer"><FaTwitter size={24} /></a></li>
            <li><a href="https://www.linkedin.com/company/c%C3%A1tedra-de-ciberseguridad-etsisi-upm-incibe" target="_blank" rel="noopener noreferrer"><FaLinkedin size={24} /></a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
